/**
 * 模組頁面代碼 : 1230-UI-01
 * 頁面說明 : 梯控歷史資料清單列表頁面
 * @module modules/elevator-control-history/components/ElevCtrlHistorygPage
 */

// ----- import from npm modules -----
import $ from 'jquery';

// ----- import from base libraries -----
import {
    React,
    PropTypes,
    BaseComponent,
    connect,
    AccessModeEnums,
    ModuleEnums,
} from '../../../components/BaseComponent';

import {
    DataTableComponent,
    batchCheckControls,
} from '../../../components/CommonComponent';

import { AlertModalModeEnums } from 'web/components/AlertModal';
import Breadcrumb from '../../../features/main-frame/components/Breadcrumb';

class ElevCtrlHistoryrPage extends BaseComponent {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.state = {
            searchBuilding: '',
            searchElevatorId: 0,
            searchUserName: '',
            searchStartDate: '',
            searchEndDate: '',
            elevatorList: null,
        };
        this.setSearchBuildingId = this.setSearchBuildingId.bind(this);
        this.setSearchElevatorId = this.setSearchElevatorId.bind(this);
        this.setSearchUserName = this.setSearchUserName.bind(this);
        this.setSearchStartDate = this.setSearchStartDate.bind(this);
        this.setSearchEndDate = this.setSearchEndDate.bind(this);
        this.setElevatorList = this.setElevatorList.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.prepareElevCtrlHistoryTable = this.prepareElevCtrlHistoryTable.bind(this);
    }

    setSearchBuildingId(searchBuildingId) {
        this.setState({ searchBuildingId });
    }

    setSearchElevatorId(searchElevatorId) {
        this.setState({ searchElevatorId });
    }

    setSearchUserName(searchUserName) {
        this.setState({ searchUserName });
    }

    setSearchStartDate(searchStartDate) {
        this.setState({ searchStartDate });
    }

    setSearchEndDate(searchEndDate) {
        this.setState({ searchEndDate });
    }

    setElevatorList(elevatorList) {
        this.setState({ elevatorList: elevatorList });
    }

    // Handle change event
    handleChange = (event) => {
        const target = event.target;
        let value = target.value;

        // 當選擇大樓時，要更新電梯選項
        if (target.id === 'searchBuildingSelection') {
            const buildingId = parseInt(value);
            this.setSearchBuildingId(buildingId);
            const building = this.props.buildingSelection.find(building => building.buildingId === buildingId);
            const elevatorList = building !== null && building !== undefined ? building.elevators : [];
            this.setState({ elevatorList });
        }
    };

    prepareElevCtrlHistoryTable = () => {
        const { elevCtrlHistoryList } = this.props;
        // 定義資料內容
        const dataSet = elevCtrlHistoryList.map((elevCtrlHistory) => {
            const gps = `${elevCtrlHistory.latitude},${elevCtrlHistory.longitude}`;
            const elevatorNum = `${elevCtrlHistory.elevatorName}(${elevCtrlHistory.elevatorNum})`;
            return [
                elevCtrlHistory.buildingName,
                elevatorNum,
                elevCtrlHistory.userName,
                elevCtrlHistory.carStatus,
                elevCtrlHistory.operateDesc,
                elevCtrlHistory.operateTime,
                gps,
            ];
        });

        // 定義欄位屬性
        const columnConfig = [
            { title: '大樓名稱', className: 'dt-center', data: 0 },
            { title: '電梯編號', className: 'dt-center', data: 1 },
            { title: '使用者', className: 'dt-center', data: 2 },
            {
                title: '電梯狀態',
                className: 'dt-center', type: 'natural',
                data: 3,
                render: function (data, type, row) {
                    // Replace "#UP#" with Bootstrap up arrow icon
                    if (data.includes('#UP#')) {
                        data = data.replace('#UP#', '<i class="bi bi-caret-up-fill" style="color: red;"></i>')
                    }
                    // Replace "#DN#" with Bootstrap up arrow icon
                    if (data.includes('#DN#')) {
                        data = data.replace('#DN#', '<i class="bi bi-caret-down-fill" style="color: green;"></i>')
                    }
                    return data
                },
            },
            {
                title: '樓層操作',
                className: 'dt-center', type: 'natural',
                data: 4,
                render: function (data, type, row) {
                    // Replace "#TO#" with Bootstrap right arrow icon
                    if (data.includes('#TO#')) {
                        data = data.replace('#TO#', '<i class="bi bi-caret-right-fill" style="color: blue;"></i>')
                    }
                    // Replace "#UP#" with Bootstrap up arrow icon
                    if (data.includes('#UP#')) {
                        data = data.replace('#UP#', '<i class="bi bi-caret-up-fill" style="color: red;"></i>')
                    }
                    // Replace "#DN#" with Bootstrap up arrow icon
                    if (data.includes('#DN#')) {
                        data = data.replace('#DN#', '<i class="bi bi-caret-down-fill" style="color: green;"></i>')
                    }
                    return data
                },
            },
            { title: '執行時間', className: 'dt-head-center', data: 5, render: DataTable.render.datetime('YYYY-MM-DD HH:mm:ss'), type: 'datetime' },
            { title: 'GPS 座標', className: 'dt-center', data: 6 },
        ];

        // 定義排序設定
        const orderConfig = {
            idx: 5,
            dir: 'dsc',
        };

        // 定義固定欄位設定
        const fixedColumnsConfig = {
            start: 1,
        };

        // 先清除datatable
        if ($.fn.DataTable.isDataTable('#datatable__elevCtrlHistoryList')) {
            $('#datatable__elevCtrlHistoryList').DataTable().destroy();
        }

        // 重新繪製datatable
        DataTableComponent('#datatable__elevCtrlHistoryList', dataSet, columnConfig, orderConfig, fixedColumnsConfig, true, true);
    }

    onNewControlCommand = () => {
        // 讀取目前電梯查詢條件
        const searchForm = new FormData(document.querySelector('.datatable__search form'));
        const buildingId = parseInt(searchForm.get('searchBuildingSelection') ? searchForm.get('searchBuildingSelection') : 0);
        const elevatorId = parseInt(searchForm.get('searchElevatorSelection') ? searchForm.get('searchElevatorSelection') : 0);
        const userName = searchForm.get('searchUserName');
        const startDate = searchForm.get('searchStartDate') + ' 00:00:00';
        const endDate = searchForm.get('searchEndDate') + ' 23:59:59';
        this.props.fetchElevCtrlHistoryList(buildingId, elevatorId, userName, startDate, endDate).then(() => {
            // Get data and redraw datatable
            this.prepareElevCtrlHistoryTable();
        });
    }

    componentDidMount() {
        // 確認是否有帳號管理讀取權限
        this.checkPermission(ModuleEnums.ELEVATOR_CONTROL_HISTORY, AccessModeEnums.READ);
        // 設定查詢日期起訖為當天
        const today = new Date();
        const formattedStartDate = today.toISOString().slice(0, 10);
        const formattedEndDate = today.toISOString().slice(0, 10);
        this.setState({ searchStartDate: formattedStartDate, searchEndDate: formattedEndDate });
    }

    componentDidUpdate(prevProps) {
        const { needElevCtrlHistoryLoad, setNeedElevCtrlHistoryLoad, elevCtrlHistoryList, newControlCommand, setNewControlCommand } = this.props;
        if (needElevCtrlHistoryLoad &&
            needElevCtrlHistoryLoad !== prevProps.needElevCtrlHistoryLoad) {
            if (elevCtrlHistoryList.length > 0) {
                this.prepareElevCtrlHistoryTable();
            }
            setNeedElevCtrlHistoryLoad(false);
        }

        if (newControlCommand && newControlCommand !== prevProps.newControlCommand) {
            this.onNewControlCommand();
            setNewControlCommand(false);
        }
    }

    handleSearch(e) {
        e.preventDefault();
        const searchForm = new FormData(e.target);
        const buildingId = parseInt(searchForm.get('searchBuildingSelection') ? searchForm.get('searchBuildingSelection') : 0);
        const elevatorId = parseInt(searchForm.get('searchElevatorSelection') ? searchForm.get('searchElevatorSelection') : 0);
        const userName = searchForm.get('searchUserName');
        const startDate = searchForm.get('searchStartDate') + ' 00:00:00';
        const endDate = searchForm.get('searchEndDate') + ' 23:59:59';
        this.props.fetchElevCtrlHistoryList(buildingId, elevatorId, userName, startDate, endDate).then(() => {
            // Get data and redraw datatable
            this.prepareElevCtrlHistoryTable();
        });
    }

    render() {
        const { buildingSelection } = this.props;
        return (
            <section id="datatable-container">
                <Breadcrumb categoryName="梯控管理" pageName="梯控歷史記錄" />
                <h4>梯控歷史記錄</h4>
                <div className="datatable__search">
                    <form className="d-flex gap-2 align-items-end needs-validation" onSubmit={this.handleSearch}>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchBuildingSelection" className="form-label">大樓名稱*</label>
                            <select
                                className="form-select form-select-sm"
                                id="searchBuildingSelection"
                                name="searchBuildingSelection"
                                value={this.state.searchBuildingId}
                                onChange={this.handleChange}
                                required>
                                <option disabled value="">請選擇</option>
                                <option value="0">全部</option>
                                {buildingSelection.map((building, index) => (
                                    <option key={index} value={building.buildingId}>{building.buildingName}</option>
                                ))}
                            </select>
                        </div>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchElevatorSelection" className="form-label">電梯編號</label>
                            <select
                                className="form-select form-select-sm"
                                id="searchElevatorSelection"
                                name="searchElevatorSelection"
                                value={this.state.searchElevatorId}
                                onChange={e => this.setSearchElevatorId(e.target.value)}
                            >
                                <option disabled value="">請選擇</option>
                                <option value="0">全部</option>
                                {this.state.elevatorList && this.state.elevatorList.map((elevator, index) => (
                                    <option key={index} value={elevator.elevatorId}>{elevator.elevatorName}</option>
                                ))}
                            </select>
                        </div>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchUserName" className="form-label">使用者</label>
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                id="searchUserName"
                                name="searchUserName"
                                value={this.state.searchUserName}
                                onChange={e => this.setSearchUserName(e.target.value)}
                            />
                        </div>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchStartDate" className="form-label">起</label>
                            <input
                                type="date"
                                className="form-control form-control-sm"
                                id="searchStartDate"
                                name="searchStartDate"
                                value={this.state.searchStartDate}
                                onChange={e => this.setSearchStartDate(e.target.value)}
                            />
                        </div>
                        <div className="flex-fill w-100">
                            <label htmlFor="searchEndDate" className="form-label">訖</label>
                            <input
                                type="date"
                                className="form-control form-control-sm"
                                id="searchEndDate"
                                name="searchEndDate"
                                value={this.state.searchEndDate}
                                onChange={e => this.setSearchEndDate(e.target.value)}
                            />
                        </div>
                        <div>
                            <button className="btn btn-primary" type="submit" aria-label="搜尋">
                                <svg className="btn__icon" aria-hidden="true">
                                    <use href="#ico-search"></use>
                                </svg>
                            </button>
                        </div>
                    </form>
                </div>
                <div className="datatable__data" ref={this.tableRef}>
                    <table id="datatable__elevCtrlHistoryList" className="display table table-hover align-middle nowrap"></table>
                </div>
            </section>
        );
    }
}

ElevCtrlHistoryrPage.propTypes = {
};

ElevCtrlHistoryrPage.defaultProps = {
};

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ElevCtrlHistoryrPage);